import { createTheme, ThemeOptions } from "@mui/material/styles";
import { globalTheme } from "App/themes";
import { PUB_PDF_FONT_FAMILY } from "./const";

const pubPdfThemeOptions: ThemeOptions = {
  ...globalTheme,
  typography: {
    ...globalTheme.typography,
    fontFamily: PUB_PDF_FONT_FAMILY
  },
  components: {
    ...globalTheme.components,
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: PUB_PDF_FONT_FAMILY
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: PUB_PDF_FONT_FAMILY
        }
      }
    }
  }
};

export const pubPdfTheme = createTheme(pubPdfThemeOptions);
